"use client"

import { PrinterCheck } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PrinterCheckIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PrinterCheckIcon = component(Icon)({ as: PrinterCheck })
